<div class="content" [ngClass]="{'display-page': DisplayMode == DisplayModes.Page, 'display-compact shadow border flex-column': DisplayMode == DisplayModes.Compact}">
    <div class="row mb-5">
        <div class="col-6 d-flex flex-row align-items-center">
            <h3 class="mr-auto" translate>TITLE.TITLE_NEW_QUESTIONNAIRE</h3>
            <button type="button" class="btn btn-success mr-4" (click)="didSaveActivate()" translate>BTN.BTN_SAVE_ACTIVATE</button>
            <button type="submit" class="btn btn-outline-success mr-2" (click)="didSubmit()" translate>BTN.BTN_SAVE</button>
            <button type="submit" class="btn btn-outline-danger mr-2" (click)="didResetModel()" translate>BTN.BTN_RESET</button>
            <button type="button" class="btn btn-outline-danger mr-2" *ngIf="EditReadModel" (click)="didCancelEdit()" translate>BTN.BTN_CANCEL</button>
        </div>
    </div>
    <div class="row flex-nowrap flex-fill">
        <div class="ml-8 col">
            <div class="row">
                <div class="col">
                    <div class="row mb-2 mt-2">
                        <div class="col-6">
                            <ErrorSummary [ErrorList]="FormErrors"></ErrorSummary>
                        </div>
                    </div>
                    <div class="row mb-4" [hidden]="lstProperties?.length == 1">

                        <div class="col-3">
                            <label translate>TITLE.TITLE_PROPERTY</label>
                            <select class="custom-select"
                                    [(ngModel)]="Model.PropertyId"
                                    name="PropertyId">
                                <option *ngFor="let row of lstProperties"
                                        [value]="row.PropertyId">
                                    {{row.PropertyName}}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="row mb-4">
                        <div class="col-6 form-group">
                            <label translate>CMB_DEF.CMB_TEMPLATE_NAME</label>
                            <input type="text" [(ngModel)]="Model.QuestionSetName" class="form-control" maxlength="40" />
                        </div>
                    </div>
                    <div class="row">
                        <!-- Questionnaire -->
                        <div class="col-6 questionnaire-container">
                            <div class="row border-bottom questionnaire-header">
                                <div class="col-8 p-1 border-right">
                                    <span class="ml-2" translate>LBL.QUESTIONS</span>
                                </div>
                                <div class="col p-1 text-center" translate>
                                    LBL.RESPONSES
                                </div>

                            </div>
                            <!-- Questions -->
                            <div class="w-100" [dragula]="'QUESTIONS'" [(dragulaModel)]="Model.Questions">
                                <ng-container *ngFor="let question of Model.Questions; trackBy: trackQuestionFunction; let index = index;">
                                    <QuestionInput [Model]="question"
                                                   [Position]="index"
                                                   [isSelected]="question.IsSelected"
                                                   (click)="didSelectQuestion($event, question)"
                                                   (didAction)="didTakeQuestionAction($event)">
                                    </QuestionInput>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
